export enum PaginatorPosition {
  start = 'start',
  end = 'end',
}
